import React from 'react';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';

// Utils
import { isSelectingSingleSelectionAndCell } from '../../../../../element/table/utils/tableCellSelectionUtils';
import { addHotTableFormulaToCell } from '../../../../../element/table/utils/hotInstanceUtils/hotTableCellFormulaUtils';

// Selectors
import { useActiveTableCallback, useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';
import { selectActiveTableCellSelection } from '../../../../../element/table/store/selectors/activeHotTableSelectors';

const TableCellFormulaTool: React.FC = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const triggerFormula = useActiveTableCallback((activeTable) => addHotTableFormulaToCell(activeTable), []);

    return (
        <div className="TableCellFormulaTool">
            <ToolbarTool
                {...props}
                onClick={triggerFormula}
                isActive={false}
                disabled={!isSelectingSingleSelectionAndCell(currentCellSelections)}
            >
                <Icon name="toolbar-formula" />
            </ToolbarTool>
        </div>
    );
};

export default TableCellFormulaTool;
